import { cn } from '@/lib/utils'
import { INSTALLER_FILE_NAME, WINDOWS_STRINGS, type WindowsLang } from './windows-strings'

const HIGHLIGHT = 'ring-2 ring-amber-400 ring-offset-2 ring-offset-[#0078D7] rounded-sm'

export function SmartScreenMock({ step, lang }: { step: 'collapsed' | 'expanded'; lang: WindowsLang }) {
  const s = WINDOWS_STRINGS[lang]

  return (
    <div aria-hidden="true" className="select-none rounded-md bg-[#0078D7] p-4 font-sans text-white shadow-lg">
      <p className="text-[17px] font-light leading-tight">{s.ssTitle}</p>
      <p className="mt-2 text-[11px] leading-snug text-white/90">{s.ssBody}</p>

      {step === 'collapsed' ? (
        <span className={cn('mt-2 inline-block text-[11px] underline', HIGHLIGHT)}>{s.ssMore}</span>
      ) : (
        <dl className="mt-2 grid grid-cols-[auto_1fr] gap-x-3 text-[11px]">
          <dt className="text-white/80">{s.ssApp}</dt>
          <dd className="truncate">{INSTALLER_FILE_NAME}</dd>
          <dt className="text-white/80">{s.ssPublisher}</dt>
          <dd>{s.ssUnknown}</dd>
        </dl>
      )}

      <div className="mt-4 flex justify-end gap-2 text-[11px]">
        {step === 'expanded' && (
          <span className={cn('border border-white/80 px-3 py-1', HIGHLIGHT)}>{s.ssRun}</span>
        )}
        <span className="border border-white/80 bg-white/10 px-3 py-1">{s.ssDontRun}</span>
      </div>
    </div>
  )
}
